import store from '../store/store.js'
// import VueRouter from 'vue-router'
import { api } from '../store/store.js';
import axios from "axios";

export default {
    methods: {
        genericSubmitHandler() {
            // add a class for the spinner here?
            store.commit('setPageLoading', true);
        
            // generic submission to API endpoint
            // get route and continue, or get error and display
        
            return new Promise((resolve, reject) => {
            
                // Disable the local active step ( will also prevent the component debounce from running )
                this.localActiveStep = '';
            
                // push to backend

                // get path
                let type = 'new'
                // convert CamelCase to lowercase-and-dashed
                let path = store.getters.currentSession.activeStepKey.replaceAll(/[A-Z]/g,'-$&').toLowerCase().replace('-vehicle.-','')

                if (store.getters.currentSession.activeStepKey.includes('VehicleAlt')) {
                    type = 'alt';
                    path = path.replace('-vehicle-alt.-','');
                }
                if (store.getters.currentSession.activeStepKey.includes('VehicleRenew')) {
                    type = 'renew';
                    path = path.replace('-vehicle-renew.-','');
                }

                axios.post(
                    api.url + api.version + 'vehicle/' + type + '/validate/' + path + '/' + store.state.session_id,
                    store.getters.flattenedAnswers[store.getters.currentSession.activeStepKey]
                )
                .then(response => {
                    store.commit('setPageLoading', false);
                    // console.log(response);

                    if ( response.data.redirect ) {
                        console.error(response.data, "Forcing redirect from stepSubmit, determine why");
                        window.location = response.data.redirect;
                        reject();
                        // throw new Error(response.data); // TODO: investigate this after plumbing in client-side error catching Sentry
                    }

                    if ( response.data.results && response.data.results.valid ) {

                        // store any data we may need for the next page
                        if ( response.data.results.decline ) {
                            store.commit('updateBackendData', {
                                'Vehicle.Sorry': {
                                    'decline': response.data.results.decline
                                }
                            });
                        }
                        if ( response.data.results.referral ) {
                            store.commit('updateBackendData', {
                                'Vehicle.Sorry': {
                                    'referral': response.data.results.referral
                                }
                            });
                        }

                        // check if hash matches
                        if ( response.data.schema_current_hash == store.getters.currentSession.schema_hash ) {

                            // save previous step
                            store.getters.currentSession.stepPath.push(response.data.results.url);

                            // route to next page
                            this.$router.push({name: response.data.results.url });

                        } else {

                            // console.log('hash: ', response.data.hash, 'expected ', store.getters.currentSession.hash );

                            //this.$router.push({name: 'Vehicle.Plate' });

                            // console.log(store.getters.currentSession.activeStepKey);

                            if (store.getters.currentSession.activeStepKey == 'Vehicle.Plate') {
                                this.$store.commit('initHash', response.data.schema_current_hash);
                            }
                            
                            let url = this.$router.resolve({name: store.getters.getStep('').replace('.','') }).href;

                            reject( ['We have updated the signup process. <a href="' + url + '">Restart the form</a>'] );
                        }

                        resolve( response.data );
                    } else {
                        if ( response.data.results && response.data.results.errors ){
                            // reject( response.data.results.errors );
                            reject( response.data.results.errors );
                        }
                        // reject( response.data );
                        reject( ['Something went wrong, please try again'] );
                    }
                })
                .catch(error => {
                    // session timeout
                    store.commit('setPageLoading', false);
                    // reject( error );
                    reject();
                });
            })
        }
    }
}
